import React from "react";
import logoheader from "../images/logo-header.png";
import brandlogo from "../images/BrandLogo2.png";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { assetsUrl, apiUrl } from "../config/config";
import axios from "axios";
import { useState, useEffect } from "react";
import Overlay from "../components/Overlay";

const ProductInvoice = () => {
  const { orderid } = useParams();
  const customerdata = useSelector((store) => store.userReducer.customerdata);
  const navigate = useNavigate();

  const [allorders, setallorders] = useState([]);
  const [order, setorder] = useState({});

  const [subtotal, setsubtotal] = useState(0);
  const [gsttotal, setgsttotal] = useState(0);

  const [promotiondiscount, setpromotiondiscount] = useState(0);
  const [total, settotal] = useState(0);

  const [loading, setloading] = useState(false);

  const [neworder, setneworder] = useState({});

  const numberToWords = (num) => {
    const ones = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const tens = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];
    const scales = ["", "Thousand", "Lakh", "Crore"]; // Indian number system

    if (num === 0) return "Zero Rupees Only";

    // Helper to convert numbers below 1000
    function getBelowThousand(n) {
      let str = "";
      if (n > 99) {
        str += ones[Math.floor(n / 100)] + " Hundred ";
        n %= 100;
      }
      if (n > 19) {
        str += tens[Math.floor(n / 10)] + " ";
        n %= 10;
      }
      if (n > 0) {
        str += ones[n] + " ";
      }
      return str.trim();
    }

    // Convert integer part
    let integerPart = Math.floor(num);
    let decimalPart = Math.round((num - integerPart) * 100); // Get two decimal places
    let words = "";
    let scaleIndex = 0;

    while (integerPart > 0) {
      let part = integerPart % 1000;
      if (part > 0) {
        const partInWords = getBelowThousand(part);
        words =
          partInWords +
          (scales[scaleIndex] ? " " + scales[scaleIndex] : "") +
          " " +
          words;
      }
      integerPart = Math.floor(integerPart / 1000);
      scaleIndex++;
    }

    words = words.trim();

    // Add decimal part if present
    if (decimalPart > 0) {
      const decimalWords = getBelowThousand(decimalPart);
      words += " and " + decimalWords + " Paise";
    }

    return words + " Only";
  };

  const fetchordershistory = async () => {
    setloading(true);
    var data = {
      orderid: orderid,
    };
    const headers = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + customerdata?.token,
      },
    };
    let resp = await axios
      .post(apiUrl + "productinvoicedetails", data, headers)
      .then((res) => {
        if (res.data.status == "success") {
          if (res.data.data) {
            setorder(res.data.data);
            

            // console.log("promodiscountedprice >>", promodiscountedprice);
          } else {
            setorder({});
          }
        } else {
        }
        setloading(false);
      })
      .catch((err) => {
        alert(err.message);
        setloading(false);
      });
    setloading(false);
  };

  const FormatDate = (isoDate) => {
    // Convert the ISO date string to a Date object
    const date = new Date(isoDate);

    // Format the date to '24 October 2024'
    const formattedDate = date.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });

    return formattedDate;
  };

  useEffect(() => {
    fetchordershistory();
  }, []);

  //   useEffect(() => {
  //     if (customerdata && Object.keys(customerdata).length > 0) {
  //     fetchordershistory();
  //     } else {
  //       navigate("/login");
  //     }
  //   }, []);

  return (
    <>
      <Overlay showloader={loading} />
      <div class="main invoicemain">
        <div class="container logoDiv">
          <div class="row">
            <div class="col-6 col-lg-6 col-md-6 col-sm-6 col-xs-6 logoLeftDiv">
              <img src={logoheader} class="logoLeft" />
            </div>
            <div class="col-6 col-lg-6 col-md-6 col-sm-6 col-xs-6 logoRightDiv">
              <img src={brandlogo} class="logoRight" />
            </div>
          </div>
        </div>
        <div class="container">
          <div class="row allAddress">
            <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8 ">
              <label for="" class="">
                Sold By:
              </label>
              <p class="vendorAdd">
                BASKING SHARK PVT. LTD.
                <br />
                GODOWN NO. 458, JAI BHAWANI INDUSTRIAL ESTATE,
                <br />
                NEAR ST. XAVIER’S SCHOOL GATE, NO 4, GHODBUNDER ROAD,
                <br />
                CHITALSAR VILLAGE, MANPADA
                <br />
                THANE (WEST) – 400 607, INDIA.
              </p>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
              <label for="" class="mobmargintop">
                Billing Address:
              </label>
              {
                order?.billing_details ?
                <p class="billingAdd">
                {JSON.parse(order?.billing_details)?.bname}
                <br />
                {JSON.parse(order?.billing_details)?.bmobile}
                <br />
                {JSON.parse(order?.billing_details)?.baddress}
                <br />
                {JSON.parse(order?.billing_details)?.selectedstate}, {JSON.parse(order?.billing_details)?.selectedcity}, {JSON.parse(order?.billing_details)?.bpincode}
              </p> : null
              }
             
            </div>
          </div>
          <div class="row allAddress detail">
            <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8">
              <label>PAN No:</label>
              <span class="panNo"> AAICB4117E</span>
              <br />
              <label>GST Registration No:</label>
              <span class="panNo"> 27AAICB4117E1ZZ</span>
              <br />
              <label>Order Number:</label>
              <span class="orderNo"> {order?.order_number}</span>
              <br />
              <label>Order Date:</label>
              <span class="orderDate">
                {" "}
                {FormatDate(
                  order?.created_at
                )}
              </span>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
              <label for="" class="mobmargintop">
                Shipping Address:
              </label>
              {
                order?.shipping_details ?
                <p class="billingAdd">
                {JSON.parse(order?.shipping_details)?.sname}
                <br />
                {JSON.parse(order?.shipping_details)?.smobile}
                <br />
                {JSON.parse(order?.shipping_details)?.saddress}
                <br />
                {JSON.parse(order?.shipping_details)?.selectedstate}, {JSON.parse(order?.shipping_details)?.selectedcity}, {JSON.parse(order?.shipping_details)?.spincode}
              </p> : null
              }

              <br />
              <label>GST Number:</label>
              <span class="invoiceNo"> {order?.user_gst}</span>
              <br />
              <label>Invoice Number:</label>
              <span class="invoiceNo"> {order?.invoice_number}</span>
              <br />
              <label>Invoice Date:</label>
              <span class="invoiceDate">
                {" "}
                {FormatDate(
                  order?.created_at
                )}
              </span>
            </div>
          </div>

          <div className="table-responsive">
            <table class="product table">
              <thead>
                <tr>
                  <th scope="col">
                    Sr.
                    <br />
                    NO
                  </th>
                  <th scope="col" class="colDiscription">
                    Name
                  </th>
                  <th scope="col" class="colDiscription">
                    HSN No.
                  </th>
                  <th scope="col" class="colDiscription">
                    SKU
                  </th>
                  <th scope="col">Unit price </th>
                  <th scope="col">Qty</th>
                  <th scope="col">
                    Net <br />
                    Amount
                  </th>
                  <th scope="col">
                    Tax <br />
                    Rate
                  </th>

                  <th scope="col">
                    Tax <br />
                    Amount
                  </th>
                  <th scope="col">
                    Total <br />
                    Amount
                  </th>
                </tr>
              </thead>
              <tbody>
              <tr>
                          <td>1</td>
                          <td>{order?.name}</td>
                          <td>{order?.hsnnumber}</td>
                          <td>{order?.sku}</td>
                          <td>{order?.unitprice}</td>
                          <td>{order?.qty}</td>
                          <td>
                            {parseFloat(order?.totalamount - order?.totalamount * 0.18).toFixed(2)}
                          </td>
                          <td>18%</td>
                          <td>{parseFloat(order?.totalamount * 0.18).toFixed(2)}</td>
                          <td>{order?.totalamount}</td>
                        </tr>

                <tr>
                  <td colspan="9" style={{ textAlign: "right" }}>
                    Shipping Charge :<br />
                    {/* Shipping Charge Net Amt :<br />
                  Shipping Charge Tax Amt: <br /> */}
                    Total Amount Before Tax: <br />
                    {Object.keys(order).length > 0 && JSON.parse(order?.billing_details)?.selectedstate == "Maharashtra" ? (
                      <>
                        CGST (9%) <br />
                        SGST (9%)
                      </>
                    ) : (
                      <>IGST (18%)</>
                    )}
                    <br />
                    Tax Amount GST
                    <br />
                    Total
                    <br />
                  </td>
                  <td class="gray">
                    {order?.shippingcharge ? order?.shippingcharge : 0}
                    <br />
                    {/* 0<br />
                  0<br /> */}
                    {parseFloat(order?.totalamount - order?.totalamount * 0.18).toFixed(2)}
                    <br />
                    {Object.keys(order).length > 0 && JSON.parse(order?.billing_details)?.selectedstate == "Maharashtra" ? (
                      <>
                        {order?.totalamount ? parseFloat((order?.totalamount * 0.18) / 2).toFixed(2) : 0}{" "}
                        <br />
                        {order?.totalamount ? parseFloat((order?.totalamount * 0.18) / 2).toFixed(2) : 0}
                      </>
                    ) : (
                      <>{order?.totalamount ? parseFloat(order?.totalamount * 0.18).toFixed(2) : 0}</>
                    )}
                    <br />
                    {order?.totalamount ? parseFloat(order?.totalamount * 0.18).toFixed(2) : 0}
                    <br />
                    {order?.totalamount}
                    <br />
                  </td>
                </tr>
                <tr>
                  <td colspan="10">
                    Amount in Words:{" "}
                    {numberToWords(order?.totalamount)}
                  </td>
                </tr>

                <tr>
                  <td colspan="10" class="rightTxt">
                    <br />
                    <br />
                    <span>Authorized Signatory</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductInvoice;
